/**
 * Language resource for text content related to book request.
 * @typedef {Object} BookRequestTextContent
 * @property {string} title - Title page for book request.
 */

/**
 * Language resource for text content related to book request.
 * @type {BookRequestTextContent}
 */
export const text = {
  title: "Book Request",
  bookName: "Book Name",
  authorName: "Author Name",
}
